import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {isEmpty} from 'lodash/lang';
import {Delete as DeleteIcon, RemoveRedEye as RemoveRedEyeIcon} from '@material-ui/icons';
import {withKluwellTableWrapper, KluwellTableCore, SortingManager, DeletionConfirmBox} from 'components/common';
import {ArchivedStatus, ArchivedOnlyTableFilter} from '../common';
import {levelMap} from 'utils/common';

class ExtraFilters extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
  };

  render() {
    const {
      values: {archivedOnly},
      onChange,
    } = this.props;
    return (
      <div className="extra-table-filters">
        <ArchivedOnlyTableFilter archivedOnly={archivedOnly} onChange={onChange} />
      </div>
    );
  }
}

const buildClassroomRecords = (classrooms) => {
  const sortedIds = classrooms.sortedIds || [];
  return isEmpty(sortedIds)
    ? []
    : sortedIds.map((classroomId) => {
        const classroom = classrooms[classroomId];
        return {
          record: classroom,
          id: classroomId,
          name: classroom.name,
          schoolName: classroom.schoolName,
          teachers: classroom.teachers,
          readers: classroom.readers,
          level: levelMap[classroom.level],
          isActive: classroom.isActive,
          actions: '',
        };
      });
};

const buildClassroomSettings = () => ({
  name: {
    fieldText: 'Name',
    sortable: true,
  },
  schoolName: {
    fieldText: 'School',
    sortable: true,
    formatData: (cell, row) => (
      <Link to={`/schools/${row.record.schoolId}`} title="view">
        {cell}
      </Link>
    ),
  },
  teachers: {
    fieldText: 'Teachers',
  },
  readers: {
    fieldText: 'Students',
  },
  level: {
    fieldText: 'App Level',
    formatData: (cell) => <span className="text-capitalize">{cell}</span>,
  },
  isActive: {
    fieldText: 'Status',
    formatData: (cell) => <ArchivedStatus isActive={cell} />,
  },
  actions: {
    fieldText: 'Actions',
    formatData: (cell, row, restProps) => (
      <span className="table-actions">
        <Link to={`/classrooms/${row.id}`} title="view">
          <RemoveRedEyeIcon />
        </Link>
        {restProps.onDeleteActionClick && (
          <DeleteIcon className="cursor-pointer" onClick={() => restProps.showDeletionConfirmBox(row)} />
        )}
      </span>
    ),
  },
});

class ClassroomTableCore extends React.Component {
  static propTypes = {
    recordPages: PropTypes.object.isRequired,
    onSortableFieldClick: PropTypes.func.isRequired,
    onDeleteActionClick: PropTypes.func,
    hiddenFields: PropTypes.array,
  };

  constructor(props) {
    super(props);
    this.state = {
      classroomToDissociate: {},
    };
    this.showDeletionConfirmBox = this.showDeletionConfirmBox.bind(this);
    this.sortingManager = new SortingManager();
  }

  showDeletionConfirmBox(classroomToDissociate) {
    this.setState(
      {
        classroomToDissociate,
      },
      () => {
        ReactDOM.findDOMNode(this.deletionConfirmBoxRef)
          .querySelector('.btn-show-confirm')
          .click();
      },
    );
  }

  render() {
    const {recordPages, onSortableFieldClick, onDeleteActionClick, hiddenFields} = this.props;
    const classrooms = recordPages[recordPages.currentPage] || {};
    const records = buildClassroomRecords(classrooms);
    const settings = buildClassroomSettings();
    return (
      <React.Fragment>
        {onDeleteActionClick && (
          <DeletionConfirmBox
            key="DeletionConfirmBox"
            ref={(ref) => (this.deletionConfirmBoxRef = ref)}
            itemName="user"
            alertText="Please confirm that you wish to remove user from this classroom"
            deleteAction={() => onDeleteActionClick(this.state.classroomToDissociate)}
            DeleteButton="span"
            confirmButtonText="OK"
          />
        )}
        <KluwellTableCore
          {...{
            records,
            settings,
            sortingManager: this.sortingManager,
            onSortableFieldClick,
            hiddenFields,
            onDeleteActionClick,
            showDeletionConfirmBox: this.showDeletionConfirmBox,
          }}
        />
      </React.Fragment>
    );
  }
}

export default withKluwellTableWrapper(ClassroomTableCore, ExtraFilters);
